import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import adminIcon from "./assets/adminIcon.svg"
import supervisorIcon from "./assets/asesorIcon.svg"
import productorIcon from "./assets/productorIcon.svg"
import laPlataIcon from "./assets/laPlataIcon.svg"
import mendozaIcon from "./assets/mendozaIcon.svg"
import contactsIcon from "./assets/contactsIcon.svg"
import asesorIcon from "./assets/asesorIcon.svg"
import seguimientosIcon from "./assets/seguimientosIcon.svg"
import iconClientes from "./assets/iconClientes.svg"
import iconCotizador from "./assets/iconCotizador.svg"
import iconAgenda from "./assets/iconAgenda.svg"


const PermisosUser = () => {
    return (

        <DivColumPlanillas>
            <FlexRow2>
                <FlexColumn>
                    <Text1>
                        TIPO DE USUARIO
                    </Text1>
                    <FlexRow>
                        <Card>
                            <IconSvG src={adminIcon} />
                            <Text2>
                                Administrador
                            </Text2>

                        </Card>
                        <Card>
                            <IconSvG src={supervisorIcon} />
                            <Text2>
                                Supervisor
                            </Text2>

                        </Card>
                        <Card>
                            <IconSvG src={productorIcon} />
                            <Text2>
                                Productor
                            </Text2>

                        </Card>
                        <Card>
                            <IconSvG src={asesorIcon} />
                            <Text2>
                                Asesor
                            </Text2>

                        </Card>
                    </FlexRow>
                </FlexColumn>

                <FlexColumn>
                    <Text1>
                        SUCURSAL
                    </Text1>
                    <FlexRow>
                        <Card>
                            <IconSvG src={laPlataIcon} />
                            <Text2>
                                La Plata
                            </Text2>

                        </Card>
                        <Card>
                            <IconSvG src={mendozaIcon} />
                            <Text2>
                                Mendoza
                            </Text2>

                        </Card>
                    </FlexRow>
                </FlexColumn>
            </FlexRow2>





            <FlexColumn>
                <Text1>
                    OPCIONES HABILITADAS
                </Text1>
                <FlexRow>
                    <Card>
                        <IconSvG src={contactsIcon} />
                        <Text2>
                            Contactos
                        </Text2>

                    </Card>
                    <Card>
                        <IconSvG src={asesorIcon} />
                        <Text2>
                            Asesores
                        </Text2>

                    </Card>
                    <Card>
                        <IconSvG src={productorIcon} />
                        <Text2>
                            Productores
                        </Text2>

                    </Card>
                    <Card>
                        <IconSvG src={seguimientosIcon} />
                        <Text2>
                            Seguimientos
                        </Text2>

                    </Card>
                    <Card>
                        <IconSvG src={iconClientes} />
                        <Text2>
                            Clientes
                        </Text2>
                    </Card>
                    <Card>
                        <IconSvG src={iconCotizador} />
                        <Text2>
                            Cotizador
                        </Text2>

                    </Card>
                    <Card>
                        <IconSvG src={iconAgenda} />
                        <Text2>
                            Agenda
                        </Text2>

                    </Card>
                </FlexRow>
            </FlexColumn>

        <FlexRow
        style={{
            alignItems:"flex-end",
            justifyContent: "end"
        }}
        >
            <Button>
                CANCELAR
            </Button>
            <Button
            
            style={{
                backgroundColor:"#334443",
                border:"solid 2px #334443",
                color: "#fcfcfc"
            }}
            >
                GUARDAR
            </Button>
        </FlexRow>

        </DivColumPlanillas>

    )
}

const Button = styled.div`
 width:84px;
 height:38px;
 font-size:12px;
font-weight:700;
letter-spacing:0px;
line-height:27px;
font-family: 'Montserrat', sans-serif;
color: #d3d3d3;
border-radius:8px;
border:solid 2px #d3d3d3;
display:flex;
flex-direction:column;
align-items:center;
justify-content:center;
cursor:pointer;
transition:all 0.5s ease-in-out;
&:hover{
    background-color: #FFFFFF !important;
    border: solid 2px #334443 !important;
    color: #334443 !important;
}
`

const IconSvG = styled.img`
 width:28px;
 height:28px;

`

const Card = styled.div`
height:76px;
width:76px;
display:flex;
flex-direction:column;
justify-content:center;
align-items:center;
border-radius:8px;
border:solid 2px #d3d3d3;
cursor:pointer;
&:hover {
    border: solid 2px #334443
}
`
const FlexRow2 = styled.div`
display: flex;
flex-direction: row;
align-items: flex-start;
width: -webkit-fill-available;
gap: 50px;
justify-content: flex-start;
`
const FlexRow = styled.div`
display: flex;
flex-direction: row;
align-items: flex-start;
width: -webkit-fill-available;
gap: 10px;
justify-content: flex-start;
`

const FlexColumn = styled.div`
display:flex;
flex-direction:column;
align-items:flex-start;
width:-webkit-fill-available;
gap:8px;
`
const Text2 = styled.span`
font-size:9px;
font-weight:700;
letter-spacing:0px;
line-height:27px;

font-family: 'Montserrat', sans-serif;
color: #334443;
`
const Text1 = styled.span`
font-size:12px;
font-weight:600;
letter-spacing:2%;

font-family: 'Montserrat', sans-serif;
color: #334443;
`

const DivColumPlanillas = styled.div`
width: calc(45% - 50px);
// max-width: calc(45% - 50px);
display:flex;
flex-direction: column;
gap:24px;
flex-grow: 1;
margin-top:8px;
margin-left:12%;
`;
export default PermisosUser;